// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__KhhXz","label":"CategoryService_label__27C_1","location":"CategoryService_location__2Q08m"};